import { MyLockerItem } from '../../types';
import { ApiBase } from './api-base';

export class LockerApi extends ApiBase {
  model = 'locker';

  myLocker(section: 'live' | 'won' | 'lost', skip?: number, limit?: number) {
    const queryParams = this.setParams({ section, skip, limit });
    return this.http.get<{ bids: MyLockerItem[]; nextPage: boolean }>(this.modelUri(''), {
      params: queryParams,
    });
  }
}
